import { useMemo } from "react";
import RatingenMetrics from "./metrics";

const numberFormater = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,

});

function MetricsContainer({ data }) {

  const actualMetrics = useMemo(() => ({
    totalLoadMetric: [{ metricName: "Water", metricScore: numberFormater.format(data?.Wasser_Hauptzugang_G69927_2100001_13_Wasser_Durchflussmenge) || "-", metricStat: "m³" }],
    totalGreenEnergy: [{ metricName: "Gas", metricScore: numberFormater.format(data?.Normvolumen_Gas_7_732_96_05_18_Durchflussmenge) ?? "-", metricStat: "m³" }],
    totalNonGreenEnergy: [{ metricName: "Energy", metricScore: numberFormater.format(data?.BHKW_Gesamtbezug_ABB_Wirk_Plus_1_Energie / 1000) ?? "-", metricStat: "MWh" }],
  }), [data]);

  const metricComponents = useMemo(
    () =>
      Object.entries(actualMetrics).map(([key, legends], index) => (
        <div
          key={key}
          className={`metrics-item col-sm-6 col-md-4 col-lg-4 col-xl-2 metrics ${index === 0 ? "metrics-first" : ""}`}
        >
          <RatingenMetrics position={3} legends={legends} />
        </div>
      )),
    [actualMetrics]
  );

  return <div className="metrics-row row">{metricComponents}</div>;
}

export default MetricsContainer;
